import { EntryCollection } from 'contentful';
import { CCPOfferingContentSkeleton } from '@atlassiansox/asc-product-catalog/src/ccp-product-catalog-client.types';

type Offering = {
  fields: {
    name: string;
    sku: string;
  };
};

export const extractOfferingSku = (
  result: EntryCollection<CCPOfferingContentSkeleton>
): string => {
  const offerings = result.items as unknown as Offering[];

  const standardOffering = offerings.find(
    (offering) => offering.fields.name === 'Standard'
  );
  if (standardOffering) {
    return standardOffering.fields.sku ?? '';
  }
  const freeOffering = offerings.find(
    (offering) => offering.fields.name === 'Free'
  );
  if (freeOffering) {
    return freeOffering.fields.sku ?? '';
  }

  const fallbackOffering = offerings[0];
  return fallbackOffering?.fields.sku ?? '';
};
